const styles = theme => ({
  header: {
    fontFamily: 'Source Sans Pro',
    marginBottom: '16px',
    fontSize: '14px'
  },
  titleText: {
    textTransform: 'uppercase',
    fontSize: '16px',
    color: '#4a4a4a',
    fontWeight: 'bold',
    letterSpacing: '1.6px'
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  subtitle: {
    marginTop: '16px',
    lineHeight: 1.25,
    color: theme.palette.text.contrastOnWhite,
    letterSpacing: '0',
    fontWeight: 400
  },
  headerLink: {
    textDecoration: 'underline !important',
    cursor: 'pointer',

    [theme.breakpoints.down(414)]: {
      display: 'none'
    }
  }
})

export default styles
